import sensors from 'sa-sdk-javascript';
import Exposure from 'sa-sdk-javascript/plugins/exposure';
import pkg from '../../../package.json';
import { isMobile } from '@/utils';
const platform = isMobile() ? 'H5' : 'PC';
/**
 *
 * @param {*} app Vue 组件实例
 * @param {Object} options
 * @param {'test'|'prod'} options.env 数据上报接入环境
 * @param {VueRouter} options.router VueRouter 实例
 * @param {Object?} options.trackOptions 初始神策sdk参数
 */
export function Track(app, options) {
  options = Object.assign(
    {
      env: 'test',
    },
    options
  );
  const listenerMaps = new WeakMap();

  const { router, env, trackOptions } = options;
  let serverUrl = '';
  if (env === 'test') {
    serverUrl = 'https://dataentry.isigning.cn/sa?project=default';
  } else {
    serverUrl = 'https://dataentry.isigning.cn/sa?project=production';
  }

  // 初始化神策SDK
  initSensors({
    server_url: serverUrl,
    show_log: env === 'test',
    ...trackOptions,
  });

  // 页面跳转数据采集
  pageTrack({ router });

  // 点击事件采集方法 挂在到全局
  if (app.prototype) {
    app.prototype.$track = $track;
    app.prototype.$trackWrapper = $trackWrapper;
    app.prototype.$login = $login;
  }

  // 提供指令采集点击事件
  app.directive('track', {
    beforeMount(el, binding) {
      const { arg: eventType = 'click', value } = binding;
      const handler = () => {
        const { eventName, ...data } = value;
        $track(eventName, data);
      };
      el.addEventListener(eventType, handler, false);
      listenerMaps.set(value, handler);
    },
    unmounted(el, binding) {
      const { arg: eventType = 'click', value } = binding;
      const handler = listenerMaps.get(value);
      handler && el.removeEventListener(eventType, handler);
    },
  });
}

function initSensors(options) {
  sensors.init(options);
  // 注册曝光采集
  if (window.SensorsDataWebJSSDKPlugin.Exposure) {
    const exposure = sensors.use(window.SensorsDataWebJSSDKPlugin.Exposure, {
      area_rate: 0,
      stay_duration: 2,
      repeated: true,
    });
  }
  sensors.quick('autoTrack');
}

function pageTrack({ router }) {
  if (!router) return;

  router.beforeEach((to, _form, next) => {
    setTimeout(() => {
      next();

      const { isTrack, title, trackData = {} } = to.meta || {};

      if (isTrack) {
        const data = {
          title,
          H1_title: null,
          H2_title: null,
          H3_title: null,
          H4_title: null,
          page_parameters: location.search || null,
          ...trackData,
        };
        $track('$pageview', data);
      }
    }, 0);
  });
}

/**
 * 事件采集
 * @param {string} name 事件名称
 * @param {Object} data 采集数据
 */
export function $track(name = 'WebsiteUsersClick', data) {
  const options = {
    apply_name: '新官网',
    platform_type: platform,
    apply_version: pkg.version,
    is_login: false,
    uid: '游客',
    user_name: '游客',
    enterprise_name: '游客',
  };
  const postData = { ...options, ...data };
  sensors.track(name, postData);
}

// 包装现有事件处理函数
export function $trackWrapper(name, data, fn) {
  try {
    return fn();
  } finally {
    sensors.track(name, data);
  }
}

/**
 * 每次登录时调用
 * @param {String} userId
 */
export function $login(userId) {
  sensors.login(userId);
}

/**
 * 曝光采集
 * @param {String} elementId
 * */
export function $exposure(elementId, options) {
  const $$exposure = window.SensorsDataWebJSSDKPlugin.Exposure;
  const exposure = sensors.use($$exposure, {
    area_rate: 0,
    stay_duration: 2,
    repeated: true,
  });
  exposure.addExposureView(document.getElementById(elementId), {
    eventName: 'activity',
    config: {
      area_rate: 0.5,
      stay_duration: 0,
      repeated: true,
    },
    properties: {
      ...options,
      e: false,
    },
    listener: {
      // 是否触发曝光事件
      shouldExpose: function (ele, properties) {
        // ele 为当前曝光的元素
        // properties 为曝光元素的元素信息及该元素的曝光自定义属性
        // 触发曝光事件则返回 true
        // 不触发曝光事件则返回 false
        return true;
      },
      // 已触发曝光回调
      didExpose: function (ele, properties) {
        // ele 为当前曝光的元素
        // properties 为曝光元素的元素信息及该元素的曝光自定义属性
      },
    },
  });
}
